import {ModuleWithProviders, NgModule} from '@angular/core';
import {
  BaseTableComponent,
  DebounceKeyupDirective,
  DebounceValuechangeDirective,
  DropDownListFilterComponent,
  DropDownListMenuFilterComponent,
  DurationAtomComponent,
  DurationPickerComponent,
  ImperialLengthPipe,
  KENDO_ANGULAR_GRID_CONFIG,
  KendoAngularGridConfig,
  KendoDropDownSearchableComponent,
  LengthEditorComponent,
  ObjectItemByValuePipe,
  ReactiveGroupBaseTableComponent,
  TimeWrapperComponent,
} from '@framewerx/kendo-angular-grid';

const FRAMEWERX_GRID_DECLARABLES = [
  BaseTableComponent,
  DebounceKeyupDirective,
  DebounceValuechangeDirective,
  DropDownListFilterComponent,
  DropDownListMenuFilterComponent,
  DurationAtomComponent,
  DurationPickerComponent,
  ImperialLengthPipe,
  KendoDropDownSearchableComponent,
  LengthEditorComponent,
  ObjectItemByValuePipe,
  ReactiveGroupBaseTableComponent,
  TimeWrapperComponent,
];

@NgModule({
  imports: [...FRAMEWERX_GRID_DECLARABLES],
  exports: [...FRAMEWERX_GRID_DECLARABLES],
})
export class KendoAngularGridModule {
  static forRoot(config: KendoAngularGridConfig): ModuleWithProviders<KendoAngularGridModule> {
    return {
      ngModule: KendoAngularGridModule,
      providers: [{provide: KENDO_ANGULAR_GRID_CONFIG, useValue: config}],
    };
  }
}
